const getTimezone = () =>
  window?.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;

export default getTimezone;
